import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useEffect, useRef } from 'react';
import { getEntityId } from 'src/checkout-frame/api/get-entity-id';
import { SegmentEvent } from 'src/types/segment';
import { printColorfulLog } from 'src/utils/print-colorful-log';
import { sendSegmentEvent } from 'src/utils/segment-api';

export interface AnalyticsType {
  onSegmentLog: (data: SegmentEvent) => void;
}

const isProduction = process.env.NODE_ENV === 'production';

export const useAnalytics = (props?: Record<string, any>): AnalyticsType => {
  const entityIdRef = useRef<string | null>(null);

  useEffect(() => {
    const initializeEntityId = async () => {
      try {
        const id = await getEntityId();
        entityIdRef.current = id;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch entityId:', error);
      }
    };

    initializeEntityId();
  }, []);

  const onSegmentLog = useCallback<AnalyticsType['onSegmentLog']>(
    ({ event, ...data }) => {
      if (!isProduction) {
        printColorfulLog('Segment', event, { ...props, ...data });
      }

      sendSegmentEvent(event, entityIdRef.current, { ...data, ...props });

      datadogRum.addAction(event, data);
    },
    [props]
  );

  return {
    onSegmentLog,
  };
};
